export default __webpack_public_path__ + "static/media/skin-tone.e0612ca2.svg";